export default __webpack_public_path__ + "static/media/volunteer5.63060452.jpg";